var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminarBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 4.44436H15.8998C15.4212 1.85941 13.3751 0.00312506 10.9999 0H8.99967C6.62448 0.00312506 4.57788 1.85941 4.09975 4.44436H0.99986C0.447663 4.44436 0 4.94176 0 5.55532C0 6.16887 0.447663 6.66628 0.99986 6.66628H1.99972V21.1108C2.003 24.1776 4.23991 26.663 6.99995 26.6667H13C15.7601 26.663 17.997 24.1776 18.0003 21.1108V6.66628H19.0001C19.5523 6.66628 20 6.16887 20 5.55532C20 4.94176 19.5523 4.44436 19.0001 4.44436H18.9997ZM8.99967 18.8889C8.99967 19.5025 8.55201 19.9999 7.99981 19.9999C7.44762 19.9999 6.99995 19.5025 6.99995 18.8889V12.2221C6.99995 11.6086 7.44762 11.1112 7.99981 11.1112C8.55201 11.1112 8.99967 11.6086 8.99967 12.2221V18.8889ZM12.9996 18.8889C12.9996 19.5025 12.5519 19.9999 11.9997 19.9999C11.4475 19.9999 10.9999 19.5025 10.9999 18.8889V12.2221C10.9999 11.6086 11.4475 11.1112 11.9997 11.1112C12.5519 11.1112 12.9996 11.6086 12.9996 12.2221V18.8889ZM6.17072 4.44436C6.59588 3.1136 7.72887 2.224 8.99967 2.22192H10.9999C12.2707 2.22348 13.4036 3.1136 13.8288 4.44436H6.17072Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminarBlanco);
export default __webpack_public_path__ + "static/media/eliminarBlanco.908b553344e714d46e163df01158c665.svg";
export { ForwardRef as ReactComponent };